import { render, staticRenderFns } from "./WriteReview.vue?vue&type=template&id=a59cc162&scoped=true&"
import script from "./WriteReview.vue?vue&type=script&lang=js&"
export * from "./WriteReview.vue?vue&type=script&lang=js&"
import style0 from "./WriteReview.vue?vue&type=style&index=0&id=a59cc162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59cc162",
  null
  
)

export default component.exports